import { post } from '@/utils/request'

/**
 * 跳转URL增加（目前必须是快站地址）
 * 
 * @param {String} url 
 */
export function admin_kuai_url_add(data) {
  return post('admin_kuai_url_add', data)
}

/**
 * 跳转URL删除（目前必须是快站地址）
 * 
 * @param {String} id 
 */
export function admin_kuai_url_delete(data) {
  return post('admin_kuai_url_delete', data)
}

/**
 * 激活使用中
 * 
 * @param {String} id 
 */
export function admin_kuai_url_active(data) {
  return post('admin_kuai_url_active', data)
}

/**
 * 跳转URL查看
 * 
 */
export function admin_kuai_url_list(data) {
  return post('admin_kuai_url_list', data)
}

